import { translate } from '@openclassrooms/translations';
import { isCurrentPath, ROUTES } from '@openclassrooms/routing';

import Typography from '@classify/react-core-components/Typography';

import mainNavigation from '../../services/mainNavigation';

import HeaderDropDown from './HeaderDropDown';
import HeaderDropDownGroup from './HeaderDropDown/HeaderDropDownGroup';
import HeaderDropDownOverTitle from './HeaderDropDown/HeaderDropDownOverTitle';

interface Props {
  name: string;
  onClick?: () => void;
}

const noop = () => {};

const TrainingDropDownMenu = ({ name, onClick = noop }: Props) => {
  const navigationConfig = mainNavigation();

  return (
    <HeaderDropDown
      name={name}
      title={
        <HeaderDropDown.Title
          title={translate('main_header.training_programs.dropdown.title')}
          subTitle={translate('main_header.training_programs.dropdown.text')}
        >
          <a
            href={ROUTES.OFFERS.INDEX}
            rel="nofollow"
            data-event="Navigation|Redirection::Internal|Trainings comparison"
          >
            <Typography variant="hyperlinkSmall" color="interaction.enabled">
              {translate('main_header.training_programs.dropdown.compare_offers')}
            </Typography>
          </a>
        </HeaderDropDown.Title>
      }
      items={[
        <HeaderDropDownGroup>
          <HeaderDropDownOverTitle
            title={{
              content: translate('main_header.training_programs.dropdown.paths.overline'),
              index: 0,
            }}
          />
          <HeaderDropDown.Item
            onClick={onClick}
            path={navigationConfig.PATHS.path}
            subTitle={translate('main_header.training_programs.dropdown.paths.text')}
            isActive={isCurrentPath(navigationConfig.PATHS.path)}
            data-event={navigationConfig.PATHS.dataEvent}
          >
            {translate('main_header.training_programs.dropdown.paths.title')}
          </HeaderDropDown.Item>
        </HeaderDropDownGroup>,
        <HeaderDropDownGroup>
          <HeaderDropDownOverTitle
            title={{
              content: translate('main_header.training_programs.dropdown.courses.overline'),
              index: 1,
            }}
          />
          <HeaderDropDown.Item
            onClick={onClick}
            path={navigationConfig.COURSES.path}
            subTitle={translate('main_header.training_programs.dropdown.courses.text')}
            isActive={isCurrentPath(navigationConfig.COURSES.path)}
            data-event={navigationConfig.COURSES.dataEvent}
          >
            {translate('main_header.training_programs.dropdown.courses.title')}
          </HeaderDropDown.Item>
        </HeaderDropDownGroup>,
      ]}
    />
  );
};

export default TrainingDropDownMenu;
